import { AxiosInstance } from 'axios';

interface Session {
    getAccessToken: () => string | null;
    refreshToken: () => Promise<string | null>;
    logout: () => void;
}

export const installAuthInterceptor = (api: AxiosInstance, session: Session): void => {
    api.interceptors.response.use((response) => response, async (error) => {
        const request = error.config;
        // Login/registration failures and refresh failures must never refresh themselves.
        if (!request || error.response?.status !== 401 || request.url?.startsWith('/auth/')) {
            return Promise.reject(error);
        }
        if (request._retry) {
            // A delayed failure for an older session must not log out a newer login.
            if (request.headers?.Authorization === `Bearer ${session.getAccessToken()}`) session.logout();
            return Promise.reject(error);
        }
        request._retry = true;
        try {
            const currentToken = session.getAccessToken();
            const token = currentToken && request.headers?.Authorization !== `Bearer ${currentToken}`
                ? currentToken
                : await session.refreshToken();
            if (!token) return Promise.reject(error);
            request.headers = request.headers || {};
            request.headers.Authorization = `Bearer ${token}`;
            return api(request);
        } catch (refreshError) {
            return Promise.reject(refreshError);
        }
    });
};
